import { render } from "./TeamAccept.vue?vue&type=template&id=45a8a30c&scoped=true"
import script from "./TeamAccept.vue?vue&type=script&lang=js"
export * from "./TeamAccept.vue?vue&type=script&lang=js"

import "./TeamAccept.vue?vue&type=style&index=0&id=45a8a30c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a8a30c"]])

export default __exports__